<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col md="5">
            <procedure-form @emitData="create"/>
        </v-col>
        <v-col md="7">
          <v-card class="card--shadow">
            <procedure-list :procedures="procedures"/>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProcedureList from '@/components/procedure/ProcedureList.vue';
import ProcedureForm from '@/components/procedure/ProcedureForm.vue';
import { mapState } from "vuex";

export default {
  components: {
    ProcedureForm,
    ProcedureList,
  },
  computed: {
    ...mapState("Procedure", ["procedures"]),
  },
  methods: {
    create(data) {
      this.$store.dispatch("Procedure/create", data);
    },
  },
  created() {
    this.$store.dispatch("Procedure/get");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
